export const customerLandingPageStore = {
  state: {
    landingPageData: {},
    catalog: {},
    categories: []
  },
  getters: {
    getCustomerLandingPageData: state => {
      return state.landingPageData;
    },
    getCustomerLandingPageCatalog: state => {
      return state.catalog;
    },
    getCustomerLandingPageCategories: state => {
      return state.categories;
    }
  },
  mutations: {
    setCustomerLandingPageData(state, value) {
      state.landingPageData = value;
    },
    setCustomerLandingPageCatalog(state, value) {
      state.catalog = value;
    },
    setCustomerLandingPageCategories(state, value) {
      state.categories = value;
    }
  }
};
